export default {
    '110000': {'l': 'B', 'n': '北京市', 'c': '110000', 'p': '86'},
    '120000': {'l': 'T', 'n': '天津市', 'c': '120000', 'p': '86'},
    '130100': {'l': 'S', 'n': '石家庄市', 'c': '130100', 'p': '130000'},
    '130200': {'l': 'T', 'n': '唐山市', 'c': '130200', 'p': '130000'},
    '130300': {'l': 'Q', 'n': '秦皇岛市', 'c': '130300', 'p': '130000'},
    '130400': {'l': 'H', 'n': '邯郸市', 'c': '130400', 'p': '130000'},
    '130500': {'l': 'X', 'n': '邢台市', 'c': '130500', 'p': '130000'},
    '130600': {'l': 'B', 'n': '保定市', 'c': '130600', 'p': '130000'},
    '130700': {'l': 'Z', 'n': '张家口市', 'c': '130700', 'p': '130000'},
    '130800': {'l': 'C', 'n': '承德市', 'c': '130800', 'p': '130000'},
    '130900': {'l': 'C', 'n': '沧州市', 'c': '130900', 'p': '130000'},
    '131000': {'l': 'L', 'n': '廊坊市', 'c': '131000', 'p': '130000'},
    '131100': {'l': 'H', 'n': '衡水市', 'c': '131100', 'p': '130000'},
    '139001': {'l': 'D', 'n': '定州市', 'c': '139001', 'p': '130000'},
    '139002': {'l': 'X', 'n': '辛集市', 'c': '139002', 'p': '130000'},
    '140100': {'l': 'T', 'n': '太原市', 'c': '140100', 'p': '140000'},
    '140200': {'l': 'D', 'n': '大同市', 'c': '140200', 'p': '140000'},
    '140300': {'l': 'Y', 'n': '阳泉市', 'c': '140300', 'p': '140000'},
    '140400': {'l': 'C', 'n': '长治市', 'c': '140400', 'p': '140000'},
    '140500': {'l': 'J', 'n': '晋城市', 'c': '140500', 'p': '140000'},
    '140600': {'l': 'S', 'n': '朔州市', 'c': '140600', 'p': '140000'},
    '140700': {'l': 'J', 'n': '晋中市', 'c': '140700', 'p': '140000'},
    '140800': {'l': 'Y', 'n': '运城市', 'c': '140800', 'p': '140000'},
    '140900': {'l': 'X', 'n': '忻州市', 'c': '140900', 'p': '140000'},
    '141000': {'l': 'L', 'n': '临汾市', 'c': '141000', 'p': '140000'},
    '141100': {'l': 'L', 'n': '吕梁市', 'c': '141100', 'p': '140000'},
    '150100': {'l': 'H', 'n': '呼和浩特市', 'c': '150100', 'p': '150000'},
    '150200': {'l': 'B', 'n': '包头市', 'c': '150200', 'p': '150000'},
    '150300': {'l': 'W', 'n': '乌海市', 'c': '150300', 'p': '150000'},
    '150400': {'l': 'C', 'n': '赤峰市', 'c': '150400', 'p': '150000'},
    '150500': {'l': 'T', 'n': '通辽市', 'c': '150500', 'p': '150000'},
    '150600': {'l': 'E', 'n': '鄂尔多斯市', 'c': '150600', 'p': '150000'},
    '150700': {'l': 'H', 'n': '呼伦贝尔市', 'c': '150700', 'p': '150000'},
    '150800': {'l': 'B', 'n': '巴彦淖尔市', 'c': '150800', 'p': '150000'},
    '150900': {'l': 'W', 'n': '乌兰察布市', 'c': '150900', 'p': '150000'},
    '152200': {'l': 'X', 'n': '兴安盟', 'c': '152200', 'p': '150000'},
    '152500': {'l': 'X', 'n': '锡林郭勒盟', 'c': '152500', 'p': '150000'},
    '152900': {'l': 'A', 'n': '阿拉善盟', 'c': '152900', 'p': '150000'},
    '210100': {'l': 'S', 'n': '沈阳市', 'c': '210100', 'p': '210000'},
    '210200': {'l': 'D', 'n': '大连市', 'c': '210200', 'p': '210000'},
    '210300': {'l': 'A', 'n': '鞍山市', 'c': '210300', 'p': '210000'},
    '210400': {'l': 'F', 'n': '抚顺市', 'c': '210400', 'p': '210000'},
    '210500': {'l': 'B', 'n': '本溪市', 'c': '210500', 'p': '210000'},
    '210600': {'l': 'D', 'n': '丹东市', 'c': '210600', 'p': '210000'},
    '210700': {'l': 'J', 'n': '锦州市', 'c': '210700', 'p': '210000'},
    '210800': {'l': 'Y', 'n': '营口市', 'c': '210800', 'p': '210000'},
    '210900': {'l': 'F', 'n': '阜新市', 'c': '210900', 'p': '210000'},
    '211000': {'l': 'L', 'n': '辽阳市', 'c': '211000', 'p': '210000'},
    '211100': {'l': 'P', 'n': '盘锦市', 'c': '211100', 'p': '210000'},
    '211200': {'l': 'T', 'n': '铁岭市', 'c': '211200', 'p': '210000'},
    '211300': {'l': 'C', 'n': '朝阳市', 'c': '211300', 'p': '210000'},
    '211400': {'l': 'H', 'n': '葫芦岛市', 'c': '211400', 'p': '210000'},
    '220100': {'l': 'C', 'n': '长春市', 'c': '220100', 'p': '220000'},
    '220200': {'l': 'J', 'n': '吉林市', 'c': '220200', 'p': '220000'},
    '220300': {'l': 'S', 'n': '四平市', 'c': '220300', 'p': '220000'},
    '220400': {'l': 'L', 'n': '辽源市', 'c': '220400', 'p': '220000'},
    '220500': {'l': 'T', 'n': '通化市', 'c': '220500', 'p': '220000'},
    '220600': {'l': 'B', 'n': '白山市', 'c': '220600', 'p': '220000'},
    '220700': {'l': 'S', 'n': '松原市', 'c': '220700', 'p': '220000'},
    '220800': {'l': 'B', 'n': '白城市', 'c': '220800', 'p': '220000'},
    '222400': {'l': 'Y', 'n': '延边朝鲜族自治州', 'c': '222400', 'p': '220000'},
    '230100': {'l': 'H', 'n': '哈尔滨市', 'c': '230100', 'p': '230000'},
    '230200': {'l': 'Q', 'n': '齐齐哈尔市', 'c': '230200', 'p': '230000'},
    '230300': {'l': 'J', 'n': '鸡西市', 'c': '230300', 'p': '230000'},
    '230400': {'l': 'H', 'n': '鹤岗市', 'c': '230400', 'p': '230000'},
    '230500': {'l': 'S', 'n': '双鸭山市', 'c': '230500', 'p': '230000'},
    '230600': {'l': 'D', 'n': '大庆市', 'c': '230600', 'p': '230000'},
    '230700': {'l': 'Y', 'n': '伊春市', 'c': '230700', 'p': '230000'},
    '230800': {'l': 'J', 'n': '佳木斯市', 'c': '230800', 'p': '230000'},
    '230900': {'l': 'Q', 'n': '七台河市', 'c': '230900', 'p': '230000'},
    '231000': {'l': 'M', 'n': '牡丹江市', 'c': '231000', 'p': '230000'},
    '231100': {'l': 'H', 'n': '黑河市', 'c': '231100', 'p': '230000'},
    '231200': {'l': 'S', 'n': '绥化市', 'c': '231200', 'p': '230000'},
    '232700': {'l': 'D', 'n': '大兴安岭地区', 'c': '232700', 'p': '230000'},
    '310000': {'l': 'S', 'n': '上海市', 'c': '310000', 'p': '86'},
    '320100': {'l': 'N', 'n': '南京市', 'c': '320100', 'p': '320000'},
    '320200': {'l': 'W', 'n': '无锡市', 'c': '320200', 'p': '320000'},
    '320300': {'l': 'X', 'n': '徐州市', 'c': '320300', 'p': '320000'},
    '320400': {'l': 'C', 'n': '常州市', 'c': '320400', 'p': '320000'},
    '320500': {'l': 'S', 'n': '苏州市', 'c': '320500', 'p': '320000'},
    '320600': {'l': 'N', 'n': '南通市', 'c': '320600', 'p': '320000'},
    '320700': {'l': 'L', 'n': '连云港市', 'c': '320700', 'p': '320000'},
    '320800': {'l': 'H', 'n': '淮安市', 'c': '320800', 'p': '320000'},
    '320900': {'l': 'Y', 'n': '盐城市', 'c': '320900', 'p': '320000'},
    '321000': {'l': 'Y', 'n': '扬州市', 'c': '321000', 'p': '320000'},
    '321100': {'l': 'Z', 'n': '镇江市', 'c': '321100', 'p': '320000'},
    '321200': {'l': 'T', 'n': '泰州市', 'c': '321200', 'p': '320000'},
    '321300': {'l': 'X', 'n': '宿迁市', 'c': '321300', 'p': '320000'},
    '330100': {'l': 'H', 'n': '杭州市', 'c': '330100', 'p': '330000'},
    '330200': {'l': 'N', 'n': '宁波市', 'c': '330200', 'p': '330000'},
    '330300': {'l': 'W', 'n': '温州市', 'c': '330300', 'p': '330000'},
    '330400': {'l': 'J', 'n': '嘉兴市', 'c': '330400', 'p': '330000'},
    '330500': {'l': 'H', 'n': '湖州市', 'c': '330500', 'p': '330000'},
    '330600': {'l': 'S', 'n': '绍兴市', 'c': '330600', 'p': '330000'},
    '330700': {'l': 'J', 'n': '金华市', 'c': '330700', 'p': '330000'},
    '330800': {'l': 'Q', 'n': '衢州市', 'c': '330800', 'p': '330000'},
    '330900': {'l': 'Z', 'n': '舟山市', 'c': '330900', 'p': '330000'},
    '331000': {'l': 'T', 'n': '台州市', 'c': '331000', 'p': '330000'},
    '331100': {'l': 'L', 'n': '丽水市', 'c': '331100', 'p': '330000'},
    '340100': {'l': 'H', 'n': '合肥市', 'c': '340100', 'p': '340000'},
    '340200': {'l': 'W', 'n': '芜湖市', 'c': '340200', 'p': '340000'},
    '340300': {'l': 'B', 'n': '蚌埠市', 'c': '340300', 'p': '340000'},
    '340400': {'l': 'H', 'n': '淮南市', 'c': '340400', 'p': '340000'},
    '340500': {'l': 'M', 'n': '马鞍山市', 'c': '340500', 'p': '340000'},
    '340600': {'l': 'H', 'n': '淮北市', 'c': '340600', 'p': '340000'},
    '340700': {'l': 'T', 'n': '铜陵市', 'c': '340700', 'p': '340000'},
    '340800': {'l': 'A', 'n': '安庆市', 'c': '340800', 'p': '340000'},
    '341000': {'l': 'H', 'n': '黄山市', 'c': '341000', 'p': '340000'},
    '341100': {'l': 'C', 'n': '滁州市', 'c': '341100', 'p': '340000'},
    '341200': {'l': 'F', 'n': '阜阳市', 'c': '341200', 'p': '340000'},
    '341300': {'l': 'X', 'n': '宿州市', 'c': '341300', 'p': '340000'},
    '341500': {'l': 'L', 'n': '六安市', 'c': '341500', 'p': '340000'},
    '341600': {'l': 'B', 'n': '亳州市', 'c': '341600', 'p': '340000'},
    '341700': {'l': 'C', 'n': '池州市', 'c': '341700', 'p': '340000'},
    '341800': {'l': 'X', 'n': '宣城市', 'c': '341800', 'p': '340000'},
    '350100': {'l': 'F', 'n': '福州市', 'c': '350100', 'p': '350000'},
    '350200': {'l': 'S', 'n': '厦门市', 'c': '350200', 'p': '350000'},
    '350300': {'l': 'P', 'n': '莆田市', 'c': '350300', 'p': '350000'},
    '350400': {'l': 'S', 'n': '三明市', 'c': '350400', 'p': '350000'},
    '350500': {'l': 'Q', 'n': '泉州市', 'c': '350500', 'p': '350000'},
    '350600': {'l': 'Z', 'n': '漳州市', 'c': '350600', 'p': '350000'},
    '350700': {'l': 'N', 'n': '南平市', 'c': '350700', 'p': '350000'},
    '350800': {'l': 'L', 'n': '龙岩市', 'c': '350800', 'p': '350000'},
    '350900': {'l': 'N', 'n': '宁德市', 'c': '350900', 'p': '350000'},
    '360100': {'l': 'N', 'n': '南昌市', 'c': '360100', 'p': '360000'},
    '360200': {'l': 'J', 'n': '景德镇市', 'c': '360200', 'p': '360000'},
    '360300': {'l': 'P', 'n': '萍乡市', 'c': '360300', 'p': '360000'},
    '360400': {'l': 'J', 'n': '九江市', 'c': '360400', 'p': '360000'},
    '360500': {'l': 'X', 'n': '新余市', 'c': '360500', 'p': '360000'},
    '360600': {'l': 'Y', 'n': '鹰潭市', 'c': '360600', 'p': '360000'},
    '360700': {'l': 'G', 'n': '赣州市', 'c': '360700', 'p': '360000'},
    '360800': {'l': 'J', 'n': '吉安市', 'c': '360800', 'p': '360000'},
    '360900': {'l': 'Y', 'n': '宜春市', 'c': '360900', 'p': '360000'},
    '361000': {'l': 'F', 'n': '抚州市', 'c': '361000', 'p': '360000'},
    '361100': {'l': 'S', 'n': '上饶市', 'c': '361100', 'p': '360000'},
    '370100': {'l': 'J', 'n': '济南市', 'c': '370100', 'p': '370000'},
    '370200': {'l': 'Q', 'n': '青岛市', 'c': '370200', 'p': '370000'},
    '370300': {'l': 'Z', 'n': '淄博市', 'c': '370300', 'p': '370000'},
    '370400': {'l': 'Z', 'n': '枣庄市', 'c': '370400', 'p': '370000'},
    '370500': {'l': 'D', 'n': '东营市', 'c': '370500', 'p': '370000'},
    '370600': {'l': 'Y', 'n': '烟台市', 'c': '370600', 'p': '370000'},
    '370700': {'l': 'W', 'n': '潍坊市', 'c': '370700', 'p': '370000'},
    '370800': {'l': 'J', 'n': '济宁市', 'c': '370800', 'p': '370000'},
    '370900': {'l': 'T', 'n': '泰安市', 'c': '370900', 'p': '370000'},
    '371000': {'l': 'W', 'n': '威海市', 'c': '371000', 'p': '370000'},
    '371100': {'l': 'R', 'n': '日照市', 'c': '371100', 'p': '370000'},
    '371200': {'l': 'L', 'n': '莱芜市', 'c': '371200', 'p': '370000'},
    '371300': {'l': 'L', 'n': '临沂市', 'c': '371300', 'p': '370000'},
    '371400': {'l': 'D', 'n': '德州市', 'c': '371400', 'p': '370000'},
    '371500': {'l': 'L', 'n': '聊城市', 'c': '371500', 'p': '370000'},
    '371600': {'l': 'B', 'n': '滨州市', 'c': '371600', 'p': '370000'},
    '371700': {'l': 'H', 'n': '菏泽市', 'c': '371700', 'p': '370000'},
    '410100': {'l': 'Z', 'n': '郑州市', 'c': '410100', 'p': '410000'},
    '410200': {'l': 'K', 'n': '开封市', 'c': '410200', 'p': '410000'},
    '410300': {'l': 'L', 'n': '洛阳市', 'c': '410300', 'p': '410000'},
    '410400': {'l': 'P', 'n': '平顶山市', 'c': '410400', 'p': '410000'},
    '410500': {'l': 'A', 'n': '安阳市', 'c': '410500', 'p': '410000'},
    '410600': {'l': 'H', 'n': '鹤壁市', 'c': '410600', 'p': '410000'},
    '410700': {'l': 'X', 'n': '新乡市', 'c': '410700', 'p': '410000'},
    '410800': {'l': 'J', 'n': '焦作市', 'c': '410800', 'p': '410000'},
    '410900': {'l': 'P', 'n': '濮阳市', 'c': '410900', 'p': '410000'},
    '411000': {'l': 'X', 'n': '许昌市', 'c': '411000', 'p': '410000'},
    '411100': {'l': 'L', 'n': '漯河市', 'c': '411100', 'p': '410000'},
    '411200': {'l': 'S', 'n': '三门峡市', 'c': '411200', 'p': '410000'},
    '411300': {'l': 'N', 'n': '南阳市', 'c': '411300', 'p': '410000'},
    '411400': {'l': 'S', 'n': '商丘市', 'c': '411400', 'p': '410000'},
    '411500': {'l': 'X', 'n': '信阳市', 'c': '411500', 'p': '410000'},
    '411600': {'l': 'Z', 'n': '周口市', 'c': '411600', 'p': '410000'},
    '411700': {'l': 'Z', 'n': '驻马店市', 'c': '411700', 'p': '410000'},
    '419001': {'l': 'J', 'n': '济源市', 'c': '419001', 'p': '410000'},
    '420100': {'l': 'W', 'n': '武汉市', 'c': '420100', 'p': '420000'},
    '420200': {'l': 'H', 'n': '黄石市', 'c': '420200', 'p': '420000'},
    '420300': {'l': 'S', 'n': '十堰市', 'c': '420300', 'p': '420000'},
    '420500': {'l': 'Y', 'n': '宜昌市', 'c': '420500', 'p': '420000'},
    '420600': {'l': 'X', 'n': '襄阳市', 'c': '420600', 'p': '420000'},
    '420700': {'l': 'E', 'n': '鄂州市', 'c': '420700', 'p': '420000'},
    '420800': {'l': 'J', 'n': '荆门市', 'c': '420800', 'p': '420000'},
    '420900': {'l': 'X', 'n': '孝感市', 'c': '420900', 'p': '420000'},
    '421000': {'l': 'J', 'n': '荆州市', 'c': '421000', 'p': '420000'},
    '421100': {'l': 'H', 'n': '黄冈市', 'c': '421100', 'p': '420000'},
    '421200': {'l': 'X', 'n': '咸宁市', 'c': '421200', 'p': '420000'},
    '421300': {'l': 'S', 'n': '随州市', 'c': '421300', 'p': '420000'},
    '422800': {'l': 'E', 'n': '恩施土家族苗族自治州', 'c': '422800', 'p': '420000'},
    '429004': {'l': 'X', 'n': '仙桃市', 'c': '429004', 'p': '420000'},
    '429005': {'l': 'Q', 'n': '潜江市', 'c': '429005', 'p': '420000'},
    '429006': {'l': 'T', 'n': '天门市', 'c': '429006', 'p': '420000'},
    '429021': {'l': 'S', 'n': '神农架林区', 'c': '429021', 'p': '420000'},
    '430100': {'l': 'C', 'n': '长沙市', 'c': '430100', 'p': '430000'},
    '430200': {'l': 'Z', 'n': '株洲市', 'c': '430200', 'p': '430000'},
    '430300': {'l': 'X', 'n': '湘潭市', 'c': '430300', 'p': '430000'},
    '430400': {'l': 'H', 'n': '衡阳市', 'c': '430400', 'p': '430000'},
    '430500': {'l': 'S', 'n': '邵阳市', 'c': '430500', 'p': '430000'},
    '430600': {'l': 'Y', 'n': '岳阳市', 'c': '430600', 'p': '430000'},
    '430700': {'l': 'C', 'n': '常德市', 'c': '430700', 'p': '430000'},
    '430800': {'l': 'Z', 'n': '张家界市', 'c': '430800', 'p': '430000'},
    '430900': {'l': 'Y', 'n': '益阳市', 'c': '430900', 'p': '430000'},
    '431000': {'l': 'C', 'n': '郴州市', 'c': '431000', 'p': '430000'},
    '431100': {'l': 'Y', 'n': '永州市', 'c': '431100', 'p': '430000'},
    '431200': {'l': 'H', 'n': '怀化市', 'c': '431200', 'p': '430000'},
    '431300': {'l': 'L', 'n': '娄底市', 'c': '431300', 'p': '430000'},
    '433100': {'l': 'X', 'n': '湘西土家族苗族自治州', 'c': '433100', 'p': '430000'},
    '440100': {'l': 'G', 'n': '广州市', 'c': '440100', 'p': '440000'},
    '440200': {'l': 'S', 'n': '韶关市', 'c': '440200', 'p': '440000'},
    '440300': {'l': 'S', 'n': '深圳市', 'c': '440300', 'p': '440000'},
    '440400': {'l': 'Z', 'n': '珠海市', 'c': '440400', 'p': '440000'},
    '440500': {'l': 'S', 'n': '汕头市', 'c': '440500', 'p': '440000'},
    '440600': {'l': 'F', 'n': '佛山市', 'c': '440600', 'p': '440000'},
    '440700': {'l': 'J', 'n': '江门市', 'c': '440700', 'p': '440000'},
    '440800': {'l': 'Z', 'n': '湛江市', 'c': '440800', 'p': '440000'},
    '440900': {'l': 'M', 'n': '茂名市', 'c': '440900', 'p': '440000'},
    '441200': {'l': 'Z', 'n': '肇庆市', 'c': '441200', 'p': '440000'},
    '441300': {'l': 'H', 'n': '惠州市', 'c': '441300', 'p': '440000'},
    '441400': {'l': 'M', 'n': '梅州市', 'c': '441400', 'p': '440000'},
    '441500': {'l': 'S', 'n': '汕尾市', 'c': '441500', 'p': '440000'},
    '441600': {'l': 'H', 'n': '河源市', 'c': '441600', 'p': '440000'},
    '441700': {'l': 'Y', 'n': '阳江市', 'c': '441700', 'p': '440000'},
    '441800': {'l': 'Q', 'n': '清远市', 'c': '441800', 'p': '440000'},
    '441900': {'l': 'D', 'n': '东莞市', 'c': '441900', 'p': '440000'},
    '442000': {'l': 'Z', 'n': '中山市', 'c': '442000', 'p': '440000'},
    '445100': {'l': 'C', 'n': '潮州市', 'c': '445100', 'p': '440000'},
    '445200': {'l': 'J', 'n': '揭阳市', 'c': '445200', 'p': '440000'},
    '445300': {'l': 'Y', 'n': '云浮市', 'c': '445300', 'p': '440000'},
    '450100': {'l': 'N', 'n': '南宁市', 'c': '450100', 'p': '450000'},
    '450200': {'l': 'L', 'n': '柳州市', 'c': '450200', 'p': '450000'},
    '450300': {'l': 'G', 'n': '桂林市', 'c': '450300', 'p': '450000'},
    '450400': {'l': 'W', 'n': '梧州市', 'c': '450400', 'p': '450000'},
    '450500': {'l': 'B', 'n': '北海市', 'c': '450500', 'p': '450000'},
    '450600': {'l': 'F', 'n': '防城港市', 'c': '450600', 'p': '450000'},
    '450700': {'l': 'Q', 'n': '钦州市', 'c': '450700', 'p': '450000'},
    '450800': {'l': 'G', 'n': '贵港市', 'c': '450800', 'p': '450000'},
    '450900': {'l': 'Y', 'n': '玉林市', 'c': '450900', 'p': '450000'},
    '451000': {'l': 'B', 'n': '百色市', 'c': '451000', 'p': '450000'},
    '451100': {'l': 'H', 'n': '贺州市', 'c': '451100', 'p': '450000'},
    '451200': {'l': 'H', 'n': '河池市', 'c': '451200', 'p': '450000'},
    '451300': {'l': 'L', 'n': '来宾市', 'c': '451300', 'p': '450000'},
    '451400': {'l': 'C', 'n': '崇左市', 'c': '451400', 'p': '450000'},
    '460100': {'l': 'H', 'n': '海口市', 'c': '460100', 'p': '460000'},
    '460200': {'l': 'S', 'n': '三亚市', 'c': '460200', 'p': '460000'},
    '460300': {'l': 'S', 'n': '三沙市', 'c': '460300', 'p': '460000'},
    '460400': {'l': 'D', 'n': '儋州市', 'c': '460400', 'p': '460000'},
    '469001': {'l': 'W', 'n': '五指山市', 'c': '469001', 'p': '460000'},
    '469002': {'l': 'Q', 'n': '琼海市', 'c': '469002', 'p': '460000'},
    '469005': {'l': 'W', 'n': '文昌市', 'c': '469005', 'p': '460000'},
    '469006': {'l': 'W', 'n': '万宁市', 'c': '469006', 'p': '460000'},
    '469007': {'l': 'D', 'n': '东方市', 'c': '469007', 'p': '460000'},
    '469021': {'l': 'D', 'n': '定安县', 'c': '469021', 'p': '460000'},
    '469022': {'l': 'T', 'n': '屯昌县', 'c': '469022', 'p': '460000'},
    '469023': {'l': 'C', 'n': '澄迈县', 'c': '469023', 'p': '460000'},
    '469024': {'l': 'L', 'n': '临高县', 'c': '469024', 'p': '460000'},
    '469025': {'l': 'B', 'n': '白沙黎族自治县', 'c': '469025', 'p': '460000'},
    '469026': {'l': 'C', 'n': '昌江黎族自治县', 'c': '469026', 'p': '460000'},
    '469027': {'l': 'L', 'n': '乐东黎族自治县', 'c': '469027', 'p': '460000'},
    '469028': {'l': 'L', 'n': '陵水黎族自治县', 'c': '469028', 'p': '460000'},
    '469029': {'l': 'B', 'n': '保亭黎族苗族自治县', 'c': '469029', 'p': '460000'},
    '469030': {'l': 'Q', 'n': '琼中黎族苗族自治县', 'c': '469030', 'p': '460000'},
    '500000': {'l': 'C', 'n': '重庆市', 'c': '500000', 'p': '86'},
    '510100': {'l': 'C', 'n': '成都市', 'c': '510100', 'p': '510000'},
    '510300': {'l': 'Z', 'n': '自贡市', 'c': '510300', 'p': '510000'},
    '510400': {'l': 'P', 'n': '攀枝花市', 'c': '510400', 'p': '510000'},
    '510500': {'l': 'L', 'n': '泸州市', 'c': '510500', 'p': '510000'},
    '510600': {'l': 'D', 'n': '德阳市', 'c': '510600', 'p': '510000'},
    '510700': {'l': 'M', 'n': '绵阳市', 'c': '510700', 'p': '510000'},
    '510800': {'l': 'G', 'n': '广元市', 'c': '510800', 'p': '510000'},
    '510900': {'l': 'S', 'n': '遂宁市', 'c': '510900', 'p': '510000'},
    '511000': {'l': 'N', 'n': '内江市', 'c': '511000', 'p': '510000'},
    '511100': {'l': 'L', 'n': '乐山市', 'c': '511100', 'p': '510000'},
    '511300': {'l': 'N', 'n': '南充市', 'c': '511300', 'p': '510000'},
    '511400': {'l': 'M', 'n': '眉山市', 'c': '511400', 'p': '510000'},
    '511500': {'l': 'Y', 'n': '宜宾市', 'c': '511500', 'p': '510000'},
    '511600': {'l': 'G', 'n': '广安市', 'c': '511600', 'p': '510000'},
    '511700': {'l': 'D', 'n': '达州市', 'c': '511700', 'p': '510000'},
    '511800': {'l': 'Y', 'n': '雅安市', 'c': '511800', 'p': '510000'},
    '511900': {'l': 'B', 'n': '巴中市', 'c': '511900', 'p': '510000'},
    '512000': {'l': 'Z', 'n': '资阳市', 'c': '512000', 'p': '510000'},
    '513200': {'l': 'A', 'n': '阿坝藏族羌族自治州', 'c': '513200', 'p': '510000'},
    '513300': {'l': 'G', 'n': '甘孜藏族自治州', 'c': '513300', 'p': '510000'},
    '513400': {'l': 'L', 'n': '凉山彝族自治州', 'c': '513400', 'p': '510000'},
    '520100': {'l': 'G', 'n': '贵阳市', 'c': '520100', 'p': '520000'},
    '520200': {'l': 'L', 'n': '六盘水市', 'c': '520200', 'p': '520000'},
    '520300': {'l': 'Z', 'n': '遵义市', 'c': '520300', 'p': '520000'},
    '520400': {'l': 'A', 'n': '安顺市', 'c': '520400', 'p': '520000'},
    '520500': {'l': 'B', 'n': '毕节市', 'c': '520500', 'p': '520000'},
    '520600': {'l': 'T', 'n': '铜仁市', 'c': '520600', 'p': '520000'},
    '522300': {'l': 'Q', 'n': '黔西南布依族苗族自治州', 'c': '522300', 'p': '520000'},
    '522600': {'l': 'Q', 'n': '黔东南苗族侗族自治州', 'c': '522600', 'p': '520000'},
    '522700': {'l': 'Q', 'n': '黔南布依族苗族自治州', 'c': '522700', 'p': '520000'},
    '530100': {'l': 'K', 'n': '昆明市', 'c': '530100', 'p': '530000'},
    '530300': {'l': 'Q', 'n': '曲靖市', 'c': '530300', 'p': '530000'},
    '530400': {'l': 'Y', 'n': '玉溪市', 'c': '530400', 'p': '530000'},
    '530500': {'l': 'B', 'n': '保山市', 'c': '530500', 'p': '530000'},
    '530600': {'l': 'Z', 'n': '昭通市', 'c': '530600', 'p': '530000'},
    '530700': {'l': 'L', 'n': '丽江市', 'c': '530700', 'p': '530000'},
    '530800': {'l': 'P', 'n': '普洱市', 'c': '530800', 'p': '530000'},
    '530900': {'l': 'L', 'n': '临沧市', 'c': '530900', 'p': '530000'},
    '532300': {'l': 'C', 'n': '楚雄彝族自治州', 'c': '532300', 'p': '530000'},
    '532500': {'l': 'H', 'n': '红河哈尼族彝族自治州', 'c': '532500', 'p': '530000'},
    '532600': {'l': 'W', 'n': '文山壮族苗族自治州', 'c': '532600', 'p': '530000'},
    '532800': {'l': 'X', 'n': '西双版纳傣族自治州', 'c': '532800', 'p': '530000'},
    '532900': {'l': 'D', 'n': '大理白族自治州', 'c': '532900', 'p': '530000'},
    '533100': {'l': 'D', 'n': '德宏傣族景颇族自治州', 'c': '533100', 'p': '530000'},
    '533300': {'l': 'N', 'n': '怒江傈僳族自治州', 'c': '533300', 'p': '530000'},
    '533400': {'l': 'D', 'n': '迪庆藏族自治州', 'c': '533400', 'p': '530000'},
    '540100': {'l': 'L', 'n': '拉萨市', 'c': '540100', 'p': '540000'},
    '540200': {'l': 'R', 'n': '日喀则市', 'c': '540200', 'p': '540000'},
    '540300': {'l': 'C', 'n': '昌都市', 'c': '540300', 'p': '540000'},
    '540400': {'l': 'L', 'n': '林芝市', 'c': '540400', 'p': '540000'},
    '540500': {'l': 'S', 'n': '山南市', 'c': '540500', 'p': '540000'},
    '542400': {'l': 'N', 'n': '那曲地区', 'c': '542400', 'p': '540000'},
    '542500': {'l': 'A', 'n': '阿里地区', 'c': '542500', 'p': '540000'},
    '610100': {'l': 'X', 'n': '西安市', 'c': '610100', 'p': '610000'},
    '610200': {'l': 'T', 'n': '铜川市', 'c': '610200', 'p': '610000'},
    '610300': {'l': 'B', 'n': '宝鸡市', 'c': '610300', 'p': '610000'},
    '610400': {'l': 'X', 'n': '咸阳市', 'c': '610400', 'p': '610000'},
    '610500': {'l': 'W', 'n': '渭南市', 'c': '610500', 'p': '610000'},
    '610600': {'l': 'Y', 'n': '延安市', 'c': '610600', 'p': '610000'},
    '610700': {'l': 'H', 'n': '汉中市', 'c': '610700', 'p': '610000'},
    '610800': {'l': 'Y', 'n': '榆林市', 'c': '610800', 'p': '610000'},
    '610900': {'l': 'A', 'n': '安康市', 'c': '610900', 'p': '610000'},
    '611000': {'l': 'S', 'n': '商洛市', 'c': '611000', 'p': '610000'},
    '620100': {'l': 'L', 'n': '兰州市', 'c': '620100', 'p': '620000'},
    '620200': {'l': 'J', 'n': '嘉峪关市', 'c': '620200', 'p': '620000'},
    '620300': {'l': 'J', 'n': '金昌市', 'c': '620300', 'p': '620000'},
    '620400': {'l': 'B', 'n': '白银市', 'c': '620400', 'p': '620000'},
    '620500': {'l': 'T', 'n': '天水市', 'c': '620500', 'p': '620000'},
    '620600': {'l': 'W', 'n': '武威市', 'c': '620600', 'p': '620000'},
    '620700': {'l': 'Z', 'n': '张掖市', 'c': '620700', 'p': '620000'},
    '620800': {'l': 'P', 'n': '平凉市', 'c': '620800', 'p': '620000'},
    '620900': {'l': 'J', 'n': '酒泉市', 'c': '620900', 'p': '620000'},
    '621000': {'l': 'Q', 'n': '庆阳市', 'c': '621000', 'p': '620000'},
    '621100': {'l': 'D', 'n': '定西市', 'c': '621100', 'p': '620000'},
    '621200': {'l': 'L', 'n': '陇南市', 'c': '621200', 'p': '620000'},
    '622900': {'l': 'L', 'n': '临夏回族自治州', 'c': '622900', 'p': '620000'},
    '623000': {'l': 'G', 'n': '甘南藏族自治州', 'c': '623000', 'p': '620000'},
    '630100': {'l': 'X', 'n': '西宁市', 'c': '630100', 'p': '630000'},
    '630200': {'l': 'H', 'n': '海东市', 'c': '630200', 'p': '630000'},
    '632200': {'l': 'H', 'n': '海北藏族自治州', 'c': '632200', 'p': '630000'},
    '632300': {'l': 'H', 'n': '黄南藏族自治州', 'c': '632300', 'p': '630000'},
    '632500': {'l': 'H', 'n': '海南藏族自治州', 'c': '632500', 'p': '630000'},
    '632600': {'l': 'G', 'n': '果洛藏族自治州', 'c': '632600', 'p': '630000'},
    '632700': {'l': 'Y', 'n': '玉树藏族自治州', 'c': '632700', 'p': '630000'},
    '632800': {'l': 'H', 'n': '海西蒙古族藏族自治州', 'c': '632800', 'p': '630000'},
    '640100': {'l': 'Y', 'n': '银川市', 'c': '640100', 'p': '640000'},
    '640200': {'l': 'S', 'n': '石嘴山市', 'c': '640200', 'p': '640000'},
    '640300': {'l': 'W', 'n': '吴忠市', 'c': '640300', 'p': '640000'},
    '640400': {'l': 'G', 'n': '固原市', 'c': '640400', 'p': '640000'},
    '640500': {'l': 'Z', 'n': '中卫市', 'c': '640500', 'p': '640000'},
    '650100': {'l': 'W', 'n': '乌鲁木齐市', 'c': '650100', 'p': '650000'},
    '650200': {'l': 'K', 'n': '克拉玛依市', 'c': '650200', 'p': '650000'},
    '650400': {'l': 'T', 'n': '吐鲁番市', 'c': '650400', 'p': '650000'},
    '650500': {'l': 'H', 'n': '哈密市', 'c': '650500', 'p': '650000'},
    '652300': {'l': 'C', 'n': '昌吉回族自治州', 'c': '652300', 'p': '650000'},
    '652700': {'l': 'B', 'n': '博尔塔拉蒙古自治州', 'c': '652700', 'p': '650000'},
    '652800': {'l': 'B', 'n': '巴音郭楞蒙古自治州', 'c': '652800', 'p': '650000'},
    '652900': {'l': 'A', 'n': '阿克苏地区', 'c': '652900', 'p': '650000'},
    '653000': {'l': 'K', 'n': '克孜勒苏柯尔克孜自治州', 'c': '653000', 'p': '650000'},
    '653100': {'l': 'K', 'n': '喀什地区', 'c': '653100', 'p': '650000'},
    '653200': {'l': 'H', 'n': '和田地区', 'c': '653200', 'p': '650000'},
    '654000': {'l': 'Y', 'n': '伊犁哈萨克自治州', 'c': '654000', 'p': '650000'},
    '654200': {'l': 'T', 'n': '塔城地区', 'c': '654200', 'p': '650000'},
    '654300': {'l': 'A', 'n': '阿勒泰地区', 'c': '654300', 'p': '650000'},
    '659001': {'l': 'S', 'n': '石河子市', 'c': '659001', 'p': '650000'},
    '659002': {'l': 'A', 'n': '阿拉尔市', 'c': '659002', 'p': '650000'},
    '659003': {'l': 'T', 'n': '图木舒克市', 'c': '659003', 'p': '650000'},
    '659004': {'l': 'W', 'n': '五家渠市', 'c': '659004', 'p': '650000'},
    '659006': {'l': 'T', 'n': '铁门关市', 'c': '659006', 'p': '650000'},
    '710101': {'l': 'J', 'n': '金门', 'c': '710101', 'p': '710000'},
    '710102': {'l': 'L', 'n': '连江', 'c': '710102', 'p': '710000'},
    '710103': {'l': 'M', 'n': '苗栗', 'c': '710103', 'p': '710000'},
    '710104': {'l': 'N', 'n': '南投', 'c': '710104', 'p': '710000'},
    '710105': {'l': 'P', 'n': '澎湖', 'c': '710105', 'p': '710000'},
    '710106': {'l': 'P', 'n': '屏东', 'c': '710106', 'p': '710000'},
    '710107': {'l': 'T', 'n': '台东', 'c': '710107', 'p': '710000'},
    '710108': {'l': 'T', 'n': '台中', 'c': '710108', 'p': '710000'},
    '710109': {'l': 'T', 'n': '台南', 'c': '710109', 'p': '710000'},
    '710110': {'l': 'T', 'n': '台北', 'c': '710110', 'p': '710000'},
    '710111': {'l': 'T', 'n': '桃园', 'c': '710111', 'p': '710000'},
    '710112': {'l': 'Y', 'n': '云林', 'c': '710112', 'p': '710000'},
    '710113': {'l': 'X', 'n': '新北', 'c': '710113', 'p': '710000'},
    '710114': {'l': 'Z', 'n': '彰化', 'c': '710114', 'p': '710000'},
    '710115': {'l': 'J', 'n': '嘉义', 'c': '710115', 'p': '710000'},
    '710116': {'l': 'X', 'n': '新竹', 'c': '710116', 'p': '710000'},
    '710117': {'l': 'H', 'n': '花莲', 'c': '710117', 'p': '710000'},
    '710118': {'l': 'Y', 'n': '宜兰', 'c': '710118', 'p': '710000'},
    '710119': {'l': 'G', 'n': '高雄', 'c': '710119', 'p': '710000'},
    '710120': {'l': 'J', 'n': '基隆', 'c': '710120', 'p': '710000'},
    '810000': {'l': 'X', 'n': '香港特别行政区', 'c': '810000', 'p': '86'},
    '820000': {'l': 'A', 'n': '澳门特别行政区', 'c': '820000', 'p': '86'}
};


// WEBPACK FOOTER //
// ./src/components/city/city.js